"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var antd_1 = require("antd");
var FontAwesome_1 = require("../../../../../../shared/components/icons/FontAwesome");
var ByBrandStatCard = /** @class */ (function (_super) {
    __extends(ByBrandStatCard, _super);
    function ByBrandStatCard(props) {
        var _this = _super.call(this, props) || this;
        _this.columns = [{
                title: 'Бренд',
                dataIndex: _this.props.data.dk_title,
                key: _this.props.data.dk_title,
                render: function (text, record, idx) { return (React.createElement("div", null,
                    React.createElement(FontAwesome_1.FA, { left: true, icon: "registered" }),
                    React.createElement("b", null, record.title))); }
            }, {
                title: 'Новых игроков',
                dataIndex: _this.props.data.dk_players_new,
                key: _this.props.data.dk_players_new,
                render: function (text, record, idx) { return (React.createElement("div", null,
                    React.createElement(FontAwesome_1.FA, { left: true, icon: "user-check" }),
                    React.createElement("b", null, record.players_new))); }
            }, {
                title: 'Всего игроков',
                dataIndex: _this.props.data.dk_players_total,
                key: _this.props.data.dk_players_total,
                render: function (text, record, idx) { return (React.createElement("div", null,
                    React.createElement(FontAwesome_1.FA, { left: true, icon: "users" }),
                    React.createElement("b", null, record.players_total))); }
            }, {
                title: 'Игроков онлайн',
                dataIndex: _this.props.data.dk_players_online,
                key: _this.props.data.dk_players_online,
                render: function (text, record, idx) { return (React.createElement("div", null,
                    React.createElement(FontAwesome_1.FA, { left: true, icon: "users" }),
                    React.createElement("b", null, record.players_online))); }
            }, {
                title: 'Сумма пополнений',
                dataIndex: _this.props.data.dk_deposit_amount,
                key: _this.props.data.dk_deposit_amount,
                render: function (text, record, idx) { return (React.createElement("div", null,
                    React.createElement(FontAwesome_1.FA, { left: true, icon: "wallet" }),
                    React.createElement("b", null,
                        record.deposit_amount.toFixed(2),
                        record.currency_symbol))); }
            }, {
                title: 'Сумма снятий',
                dataIndex: _this.props.data.dk_withdraw_amount,
                key: _this.props.data.dk_withdraw_amount,
                render: function (text, record, idx) { return (React.createElement("div", null,
                    React.createElement(FontAwesome_1.FA, { left: true, icon: "wallet" }),
                    React.createElement("b", null,
                        record.withdraw_amount.toFixed(2),
                        record.currency_symbol))); }
            }, {
                title: 'Выручка бренда',
                dataIndex: _this.props.data.dk_profit_amount,
                key: _this.props.data.dk_profit_amount,
                render: function (text, record, idx) { return (React.createElement("div", null,
                    React.createElement(FontAwesome_1.FA, { left: true, icon: "hand-holding-usd" }),
                    React.createElement("b", null,
                        record.profit_amount.toFixed(2),
                        record.currency_symbol))); }
            }];
        return _this;
    }
    ByBrandStatCard.prototype.componentWillMount = function () {
        var _this = this;
        this.SID = this.props.data.Subscribe("*", function (id, data) {
            _this.setState({
                data: data.data_by_brands
            });
        });
        this.SID_STATE = this.props.state.Subscribe("*", function (id, data) {
            _this.setState({
                dtFrom: data.dtFrom,
                dtTo: data.dtTo,
                dtFormat: data.dtTimeFormat
            });
        });
        this.setState({
            data: this.props.data.DATA.data_by_brands,
            dtFrom: this.props.state.DATA.dtFrom,
            dtTo: this.props.state.DATA.dtTo,
            dtFormat: this.props.state.DATA.dtTimeFormat
        }, function () {
            _this.loadData();
        });
    };
    ByBrandStatCard.prototype.loadData = function () {
        this.props.data.LoadBrandsData({
            from_year: this.state.dtFrom.get('year'),
            from_month: this.state.dtFrom.get('month') + 1,
            from_day: this.state.dtFrom.get('date'),
            from_hour: this.state.dtFrom.get('hour'),
            from_minute: this.state.dtFrom.get('minute'),
            from_second: this.state.dtFrom.get('second'),
            to_year: this.state.dtTo.get('year'),
            to_month: this.state.dtTo.get('month') + 1,
            to_day: this.state.dtTo.get('date'),
            to_hour: this.state.dtTo.get('hour'),
            to_minute: this.state.dtTo.get('minute'),
            to_second: this.state.dtTo.get('second'),
        }, function () { });
    };
    ByBrandStatCard.prototype.componentWillUnmount = function () {
        this.props.data.UnSubscribe(this.SID);
        this.props.state.UnSubscribe(this.SID_STATE);
    };
    ByBrandStatCard.prototype.render = function () {
        return (React.createElement(antd_1.Card, { bordered: false, title: "Статистика по брендам", style: { margin: "0px", padding: "0px", width: "100%", height: "100%" } },
            React.createElement(antd_1.Table, { style: { margin: "0px", padding: "0px" }, columns: this.columns, dataSource: this.state.data, pagination: false, footer: function (data) {
                    return React.createElement("div", null,
                        "\u041E\u0442\u043E\u0431\u0440\u0430\u0436\u0430\u0435\u0442\u0441\u044F : ",
                        data.length,
                        " \u0437\u0430\u043F\u0438\u0441\u0435\u0439");
                }, expandedRowRender: function (record) { return React.createElement("p", { style: { margin: 0 } },
                    React.createElement("b", null, "\u0418\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u044F \u043F\u043E \u0431\u0440\u0435\u043D\u0434\u0443 :"),
                    "[",
                    record.title,
                    "]"); } })));
    };
    return ByBrandStatCard;
}(React.Component));
exports.default = ByBrandStatCard;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/main_dashboard/ui/component/ByBrandStatCard.tsx
// module id = 1749
// module chunks = 0